<template>
  <FormTextarea
    :model-value="answer?.answer"
                @update:modelValue="updateAnswer"
                :max-length="props.maxLength"
                :default-height="props.defaultHeight"
                placeholder="Make your application stand out with a great answer..."
                class="mt-1"
  />
</template>

<script setup>
import FormTextarea from "./FormTextarea.vue";

const emits = defineEmits(["update:answer"]);
const props = defineProps({
  answer: {
    type: Object,
    default: null,
  },
  maxLength: {
    type: Number,
    default: 255,
  },
  defaultHeight: {
    type: Number,
    default: 128,
  },
});

const updateAnswer = (value) => {
  emits("update:answer", { value });
};
</script>
